// FE-84 (21.10.2026): 3750 satırlık Services.js alan dosyalarına bölündü (services/alanlar/*.js). Dışarıya AYNI nesne
// verilir: import Services from ".../services/Services" ve Services.X() çağrıları değişmez. Ortak kısım: servisOrtak.js.
import servisKullanici from "./alanlar/kullanici";
import servisTroyi from "./alanlar/troyi";
import servisGenelbakis from "./alanlar/genelbakis";
import servisDepo from "./alanlar/depo";
import servisGenel from "./alanlar/genel";
import servisTalep from "./alanlar/talep";
import servisWeb from "./alanlar/web";
import servisFirma from "./alanlar/firma";
import servisOdeme from "./alanlar/odeme";
import servisOperasyon from "./alanlar/operasyon";
import servisTeklif from "./alanlar/teklif";
import servisMagaza from "./alanlar/magaza";
import servisSozlesme from "./alanlar/sozlesme";
import servisBildirim from "./alanlar/bildirim";

export { invalidateUserInfosCache } from "./servisOrtak";

const Services = {
  ...servisKullanici,
  ...servisTroyi,
  ...servisGenelbakis,
  ...servisDepo,
  ...servisGenel,
  ...servisTalep,
  ...servisWeb,
  ...servisFirma,
  ...servisOdeme,
  ...servisOperasyon,
  ...servisTeklif,
  ...servisMagaza,
  ...servisSozlesme,
  ...servisBildirim,
};

export default Services;
